module.exports = __webpack_public_path__ + "img/job.89eabe9f.png";